import { QuestionCircleOutlined } from '@ant-design/icons'
import { Check, Edit, X } from 'react-feather'
import { createSelector } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, Typography, Popover, Card, Radio, Select, Switch } from 'antd'
import { getNamespaces } from 'Services/WeaverUtils'
import WeaverService from 'Services/WeaverService'
import { setIdPrefix, setIdType } from 'Actions/explore'
import { IdFormat } from 'Model'
import { useEffect, useState } from 'react'

const { Paragraph, Text } = Typography

const helpText = (
  <div style={{ width: 500, lineHeight: '1.6rem', whiteSpace: 'pre-wrap' }}>
    <Paragraph>
      Setting an <Text mark>Id Prefix</Text> provides a default prefix when creating nodes and relations.
    </Paragraph>
    <Text type="secondary">
      The prefix should exist in the <Text mark>Namespace</Text> list. This means prefixed identifiers should be valid URIs
    </Text>
  </div>
)

const info = (
  <Popover
    content={helpText}
    title='Node Id Formatting'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

const idTypeSelector = createSelector((state) => state.explore.idType, (val) => val)
const idPrefixSelector = createSelector((state) => state.explore.idPrefix, (val) => val)

export default () => {
  const idType = useSelector(idTypeSelector)
  const idPrefix = useSelector(idPrefixSelector)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [configNode, setConfigNode] = useState()
  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    (async () => {
      const node = await IdFormat.load()
      setConfigNode(node)
      setLoading(false)
    })()
    undefined
  }, [])

  const commitChanges = ({ type, prefix }) => {
    dispatch(setIdType(type))
    dispatch(setIdPrefix(prefix))
    configNode.setIdType(type)
    configNode.setPrefix(prefix)
    Weaver.useIdentifier(type)
    Weaver.prefixIdentifier(prefix)
  }

  const checkButton = (
    <Form.Item>
      <Button
        type="text"
        htmlType="submit"
      >
        <Check />
      </Button>
    </Form.Item>
  )

  const cancelButton = (
    <Button type="text">
      <X />
    </Button>
  )

  const editButton = (
    <Button
      type="text"
      disabled={!WeaverService.userCanEdit()}
      onClick={() => setIsEditing(true)}
    >
      <Edit />
    </Button>
  )

  const actions = isEditing ? [checkButton, cancelButton] : [editButton]

  const prefixSelector = (
    <Select disabled={!isEditing}>
      <Select.Option key='empty' value=''>No prefix</Select.Option>
      {_.map(getNamespaces(), (value, key) => <Select.Option key={key} value={key}>{ key }</Select.Option>)}
    </Select>
  )

  return (
    <Form
      onFinish={(vals) => {
        commitChanges(vals)
        setIsEditing(false)
      }}
      initialValues={{
        type: idType,
        prefix: idPrefix
      }}
    >
      <Card
        title="Node Id Format"
        loading={loading}
        extra={info}
        size="small"
        id="open-default-view-settings"
        actions={actions}
      >
        <Form.Item
          label="Id type"
          name="type"
        >
          <Radio.Group disabled={!isEditing}>
            {['cuid', 'uuid'].map((val) => <Radio.Button key={val} value={val}>{ val }</Radio.Button>)}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Id prefix"
          name="prefix"
        >
          { prefixSelector }
        </Form.Item>
      </Card>
    </Form>
  )
}
